webpackJsonp([1],{

/***/ 2704:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(787);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _reactRedux = __webpack_require__(2623);
	
	var _redux = __webpack_require__(684);
	
	var _Anchorman = __webpack_require__(2705);
	
	var _Anchorman2 = _interopRequireDefault(_Anchorman);
	
	var _actions = __webpack_require__(620);
	
	var _selectors = __webpack_require__(2748);
	
	var _constants = __webpack_require__(618);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    savedReports: (0, _extends3.default)({}, state.reportManagement.savedReports, {
	      data: (0, _selectors.buildPlatformSpecificReports)(state),
	      maxFavourites: _constants.SAVED_REPORT_MAX_FAVOURITES
	    }),
	    platform: state.session.currentPlatformType,
	    userId: state.session.user.id,
	    createReportFailMessage: state.reportManagement.global.createReportFailMessage,
	    isPackage: state.session.isPackage
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    savedReportActions: {
	      onSelect: (0, _redux.bindActionCreators)(_actions.savedReportsOnSelect, dispatch),
	      onFav: (0, _redux.bindActionCreators)(_actions.savedReportsOnFavourite, dispatch),
	      onDelete: (0, _redux.bindActionCreators)(_actions.savedReportsOnDelete, dispatch),
	      onDuplicate: (0, _redux.bindActionCreators)(_actions.savedReportsOnDuplicate, dispatch)
	    },
	    removeGlobalReportFailMessage: (0, _redux.bindActionCreators)(_actions.savedReportsOnDuplicateFail, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Anchorman2.default);

/***/ },

/***/ 2705:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__(787);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(1316);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(794);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(795);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(796);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(814);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp2;
	
	var _react = __webpack_require__(301);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutabilityHelper = __webpack_require__(1644);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _antd = __webpack_require__(781);
	
	var _reactIntl = __webpack_require__(2594);
	
	var _propTypes = __webpack_require__(720);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _megaBlocs = __webpack_require__(2706);
	
	__webpack_require__(2747);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Anchorman = (_temp2 = _class = function (_Component) {
	  (0, _inherits3.default)(Anchorman, _Component);
	
	  function Anchorman() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Anchorman);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Anchorman.__proto__ || (0, _getPrototypeOf2.default)(Anchorman)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isModalVisible: false,
	      isErrorModalVisible: false,
	      newReportName: '',
	      newReportId: null
	    }, _this.componentWillReceiveProps = function (nextProps) {
	      if (nextProps.createReportFailMessage === null) {
	        _this.setState({
	          isModalVisible: false,
	          newReportName: '',
	          newReportId: null
	        });
	      }
	    }, _this.isReportCreatedByCurrentUser = function (reportId) {
	      var _this2 = _this,
	          props = _this2.props;
	
	      var report = props.savedReports.data.find(function (report) {
	        return report.id === reportId;
	      });
	      return report.created_by === props.userId;
	    }, _this.onFavRestriction = function (reportId, favId) {
	      if (favId) _this.props.savedReportActions.onFav(reportId, favId); // Un-favoriting
	      else if (_this.isReportCreatedByCurrentUser(reportId)) _this.props.savedReportActions.onFav(reportId, favId); // Favoriting
	        else {
	            // User does not own the report and need to create a new report
	            var newReportName = _this.props.savedReports.data.find(function (report) {
	              return report.id === reportId;
	            }).key + '(1)';
	            _this.setState({
	              isModalVisible: true,
	              newReportName: newReportName,
	              newReportId: reportId
	            });
	          }
	    }, _this.onDeleteRestriction = function (reportId) {
	      if (_this.isReportCreatedByCurrentUser(reportId)) {
	        _this.props.savedReportActions.onDelete(reportId);
	      } else {
	        _this.setState({
	          isErrorModalVisible: true
	        });
	        _antd.Modal.error({
	          title: 'Error Deleting Report',
	          content: _react2.default.createElement(
	            'span',
	            null,
	            'Since you are not the owner of ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              _this.props.savedReports.data.find(function (report) {
	                return report.id === reportId;
	              }).key
	            ),
	            ', you cannot delete it.'
	          ),
	          zIndex: 2000,
	          onOk: function onOk(closeModal) {
	            _this.setState({ isErrorModalVisible: false });closeModal();
	          }
	        });
	      }
	    }, _this.onModalOk = function () {
	      var _this$state = _this.state,
	          newReportId = _this$state.newReportId,
	          newReportName = _this$state.newReportName;
	
	      _this.props.savedReportActions.onDuplicate(newReportId, { key: newReportName });
	    }, _this.onModalCancel = function () {
	      _this.props.removeGlobalReportFailMessage();
	      _this.setState({
	        isModalVisible: false,
	        newReportName: '',
	        newReportId: null
	      });
	    }, _this.determinePopupContainerLocation = function (triggerNode) {
	      if (_this.props.isPackage) return $(triggerNode).closest('.ReportManagement__Component')[0];
	      return document.getElementsByClassName('ReportManagement__Component')[0];
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Anchorman, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          newReportName = _state.newReportName,
	          isModalVisible = _state.isModalVisible,
	          isErrorModalVisible = _state.isErrorModalVisible;
	      var _props = this.props,
	          platform = _props.platform,
	          createReportFailMessage = _props.createReportFailMessage,
	          savedReports = _props.savedReports,
	          savedReportActions = _props.savedReportActions;
	
	      var modifiedSavedReports = (0, _immutabilityHelper2.default)(savedReports, {
	        actions: (0, _extends3.default)({ $merge: savedReportActions }, {
	          onFav: { $set: this.onFavRestriction },
	          onDelete: { $set: this.onDeleteRestriction }
	        })
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'Anchorman__Component' },
	        _react2.default.createElement(
	          _antd.Modal,
	          {
	            title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Anchorman.modal.title.label', defaultMessage: 'Create your own copy of this report (so you can edit it later).' }),
	            visible: isModalVisible,
	            okText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Anchorman.modal.create.button.label', defaultMessage: 'Create' }),
	            onOk: function onOk() {
	              return _this3.onModalOk();
	            },
	            onCancel: function onCancel() {
	              return _this3.onModalCancel();
	            },
	            zIndex: 2000
	          },
	          createReportFailMessage && _react2.default.createElement(
	            'span',
	            { className: 'anchorman-create-report-fail-message' },
	            createReportFailMessage
	          ),
	          _react2.default.createElement(_antd.Input, { value: newReportName, onChange: function onChange(event) {
	              return _this3.setState({ newReportName: event.target.value });
	            } })
	        ),
	        _react2.default.createElement(_megaBlocs.ReportManagement, {
	          platform: platform,
	          savedReports: modifiedSavedReports,
	          isModalVisible: isModalVisible || isErrorModalVisible,
	          determinePopupContainerLocation: this.determinePopupContainerLocation
	        })
	      );
	    }
	  }]);
	  return Anchorman;
	}(_react.Component), _class.propTypes = {
	  platform: _propTypes2.default.string.isRequired,
	  createReportFailMessage: _propTypes2.default.string,
	  removeGlobalReportFailMessage: _propTypes2.default.func.isRequired,
	  savedReportActions: _propTypes2.default.shape({
	    onFav: _propTypes2.default.func.isRequired,
	    onSelect: _propTypes2.default.func.isRequired,
	    onDelete: _propTypes2.default.func.isRequired,
	    onDuplicate: _propTypes2.default.func.isRequired
	  }).isRequired,
	  savedReports: _propTypes2.default.shape({
	    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      id: _propTypes2.default.number.isRequired,
	      advertiser_id: _propTypes2.default.number.isRequired,
	      group: _propTypes2.default.string.isRequired,
	      key: _propTypes2.default.string.isRequired,
	      value: _propTypes2.default.string.isRequired
	    }))
	  }).isRequired,
	  isPackage: _propTypes2.default.bool
	}, _class.defaultProps = {
	  createReportFailMessage: null,
	  isPackage: true
	}, _temp2);
	exports.default = Anchorman;

/***/ },

/***/ 2706:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ReportManagement = __webpack_require__(2707);
	
	Object.defineProperty(exports, 'ReportManagement', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ReportManagement).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },

/***/ 2707:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ReportManagement = __webpack_require__(2708);
	
	var _ReportManagement2 = _interopRequireDefault(_ReportManagement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ReportManagement2.default;

/***/ },

/***/ 2708:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__(787);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(1316);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(794);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(795);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(796);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(814);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp2;
	
	var _react = __webpack_require__(301);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(781);
	
	var _isEmpty = __webpack_require__(2709);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _propTypes = __webpack_require__(720);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(2594);
	
	__webpack_require__(2746);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReportManagement = (_temp2 = _class = function (_Component) {
	  (0, _inherits3.default)(ReportManagement, _Component);
	
	  function ReportManagement() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ReportManagement);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ReportManagement.__proto__ || (0, _getPrototypeOf2.default)(ReportManagement)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      tooltipVisible: true
	    }, _this.tooltipVisibleToggle = function (visible) {
	      _this.setState({
	        tooltipVisible: !visible
	      });
	    }, _this.onDelete = function (e, reportId) {
	      e.stopPropagation();
	      _this.props.savedReports.actions.onDelete(reportId);
	    }, _this.onFav = function (e, reportId) {
	      var favId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	      e.stopPropagation();
	      _this.props.savedReports.actions.onFav(reportId, favId);
	    }, _this.onSelect = function (reportId) {
	      if (reportId) _this.props.savedReports.actions.onSelect(reportId);
	    }, _this.onChange = function (value) {
	      _this.props.savedReports.actions.onSelect(value[1]);
	    }, _this.renderFavIcon = function (reportId) {
	      var favId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	      var maxAmountOfFavouritesReached = arguments[2];
	
	      if (maxAmountOfFavouritesReached && favId === null) {
	        // Trying to favourite when max amount of favourite is reached
	        var maxFavourites = _this.props.savedReports.maxFavourites;
	
	        return _react2.default.createElement(
	          _antd.Tooltip,
	          {
	            title: _react2.default.createElement(_reactIntl.FormattedMessage, {
	              id: 'Mega-blocs.ReportManagement.savedReports.Tooltip.maxFavourites.label',
	              defaultMessage: 'You\u2019ve reached {maxFavourites} maximum saved favorites.',
	              values: { maxFavourites: maxFavourites }
	            }),
	            placement: 'right'
	          },
	          _react2.default.createElement(_antd.Icon, { type: 'star', className: 'disable-star', onClick: function onClick(e) {
	              return e.stopPropagation();
	            } })
	        );
	      }
	      return _react2.default.createElement(_antd.Icon, { onClick: function onClick(e) {
	          return _this.onFav(e, reportId, favId);
	        }, type: 'star', className: favId ? 'checked' : '' });
	    }, _this.noSavedReportsAvailableOption = function () {
	      return {
	        value: 'noSavedReportsAvailable',
	        label: _react2.default.createElement(
	          'div',
	          { onClick: function onClick(e) {
	              return e.stopPropagation();
	            } },
	          _react2.default.createElement(_reactIntl.FormattedMessage, {
	            id: 'Mega-blocs.ReportManagement.savedReports.noSavedReportsAvailable.label',
	            defaultMessage: 'No Saved Reports Available'
	          })
	        )
	      };
	    }, _this.optionsBuilder = function () {
	      var options = [];
	      var _this$props = _this.props,
	          platform = _this$props.platform,
	          savedReports = _this$props.savedReports;
	
	      var platformFavourites = savedReports.favourites[platform];
	      var anyFavouritesAvailable = !(0, _isEmpty2.default)(platformFavourites);
	      var maxAmountOfFavouritesReached = anyFavouritesAvailable ? platformFavourites.length >= savedReports.maxFavourites : false;
	
	      if (savedReports && savedReports.data) {
	        var savedReportOptions = {
	          value: 'savedReports',
	          label: 'Saved Reports',
	          children: savedReports.data.length === 0 ? [_this.noSavedReportsAvailableOption()] : savedReports.data.map(function (report) {
	            var isFav = platformFavourites.find(function (fav) {
	              return report.id === fav.reportId;
	            });
	
	            return {
	              value: report.id,
	              label: _react2.default.createElement(
	                'div',
	                { className: 'saved-report-label' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  report.key
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'action-icons' },
	                  _this.renderFavIcon(report.id, isFav && isFav.id, maxAmountOfFavouritesReached),
	                  _react2.default.createElement(
	                    _antd.Popconfirm,
	                    {
	                      onVisibleChange: function onVisibleChange(visible) {
	                        return _this.tooltipVisibleToggle(visible);
	                      },
	                      title: _react2.default.createElement(_reactIntl.FormattedMessage, {
	                        id: 'Mega-blocs.ReportManagement.savedReports.Popconfirm.onDelete.label',
	                        defaultMessage: 'Are you sure you want to delete this report?'
	                      }),
	                      placement: 'right',
	                      onConfirm: function onConfirm(e) {
	                        return _this.onDelete(e, report.id);
	                      },
	                      getPopupContainer: function getPopupContainer(triggerNode) {
	                        return _this.props.determinePopupContainerLocation(triggerNode);
	                      }
	                    },
	                    _react2.default.createElement(_antd.Icon, { onClick: function onClick(e) {
	                        return e.stopPropagation();
	                      }, type: 'delete' })
	                  )
	                )
	              )
	            };
	          })
	        };
	
	        options.push(savedReportOptions);
	      }
	
	      return options;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ReportManagement, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var extraCascaderProps = {};
	
	      if (this.props.isModalVisible || !this.state.tooltipVisible) {
	        extraCascaderProps.popupVisible = true;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ReportManagement__Component' },
	        _react2.default.createElement(_antd.Cascader, (0, _extends3.default)({}, extraCascaderProps, {
	          value: [],
	          onChange: function onChange(value) {
	            return _this2.onChange(value);
	          },
	          placeholder: 'Select Reports',
	          options: this.optionsBuilder(),
	          getPopupContainer: function getPopupContainer(triggerNode) {
	            return _this2.props.determinePopupContainerLocation(triggerNode);
	          }
	        }))
	      );
	    }
	  }]);
	  return ReportManagement;
	}(_react.Component), _class.propTypes = {
	  savedReports: _propTypes2.default.shape({
	    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      id: _propTypes2.default.number.isRequired,
	      advertiser_id: _propTypes2.default.number.isRequired,
	      key: _propTypes2.default.string.isRequired,
	      value: _propTypes2.default.string.isRequired
	    })),
	    maxFavourites: _propTypes2.default.number.isRequired,
	    actions: _propTypes2.default.shape({
	      onSelect: _propTypes2.default.func,
	      onFav: _propTypes2.default.func,
	      onDelete: _propTypes2.default.func
	    }).isRequired
	  }).isRequired,
	  isModalVisible: _propTypes2.default.bool.isRequired,
	  platform: _propTypes2.default.string.isRequired,
	  determinePopupContainerLocation: _propTypes2.default.func.isRequired
	}, _temp2);
	exports.default = ReportManagement;

/***/ },

/***/ 2709:
/***/ function(module, exports, __webpack_require__) {

	var baseKeys = __webpack_require__(2710),
	    getTag = __webpack_require__(2714),
	    isArguments = __webpack_require__(2734),
	    isArray = __webpack_require__(2737),
	    isArrayLike = __webpack_require__(2738),
	    isBuffer = __webpack_require__(2740),
	    isPrototype = __webpack_require__(2711),
	    isTypedArray = __webpack_require__(2742);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if `value` is an empty object, collection, map, or set.
	 *
	 * Objects are considered empty if they have no own enumerable string keyed
	 * properties.
	 *
	 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	 * jQuery-like collections are considered empty if they have a `length` of `0`.
	 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (value == null) {
	    return true;
	  }
	  if (isArrayLike(value) &&
	      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	    return !value.length;
	  }
	  var tag = getTag(value);
	  if (tag == mapTag || tag == setTag) {
	    return !value.size;
	  }
	  if (isPrototype(value)) {
	    return !baseKeys(value).length;
	  }
	  for (var key in value) {
	    if (hasOwnProperty.call(value, key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = isEmpty;


/***/ },

/***/ 2710:
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(2711),
	    nativeKeys = __webpack_require__(2712);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },

/***/ 2711:
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },

/***/ 2712:
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(2713);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },

/***/ 2713:
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },

/***/ 2714:
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(2715),
	    Map = __webpack_require__(2730),
	    Promise = __webpack_require__(2731),
	    Set = __webpack_require__(2732),
	    WeakMap = __webpack_require__(2733),
	    baseGetTag = __webpack_require__(2719),
	    toSource = __webpack_require__(2728);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },

/***/ 2715:
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(2716),
	    root = __webpack_require__(2721);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },

/***/ 2716:
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(2717),
	    getValue = __webpack_require__(2729);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },

/***/ 2717:
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(2718),
	    isMasked = __webpack_require__(2726),
	    isObject = __webpack_require__(2725),
	    toSource = __webpack_require__(2728);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },

/***/ 2718:
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(2719),
	    isObject = __webpack_require__(2725);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },

/***/ 2719:
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(2720),
	    getRawTag = __webpack_require__(2723),
	    objectToString = __webpack_require__(2724);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },

/***/ 2720:
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(2721);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },

/***/ 2721:
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(2722);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },

/***/ 2722:
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ 2723:
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(2720);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },

/***/ 2724:
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },

/***/ 2725:
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },

/***/ 2726:
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(2727);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },

/***/ 2727:
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(2721);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },

/***/ 2728:
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },

/***/ 2729:
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },

/***/ 2730:
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(2716),
	    root = __webpack_require__(2721);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },

/***/ 2731:
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(2716),
	    root = __webpack_require__(2721);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },

/***/ 2732:
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(2716),
	    root = __webpack_require__(2721);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },

/***/ 2733:
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(2716),
	    root = __webpack_require__(2721);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },

/***/ 2734:
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(2735),
	    isObjectLike = __webpack_require__(2736);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },

/***/ 2735:
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(2719),
	    isObjectLike = __webpack_require__(2736);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },

/***/ 2736:
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },

/***/ 2737:
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },

/***/ 2738:
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(2718),
	    isLength = __webpack_require__(2739);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },

/***/ 2739:
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },

/***/ 2740:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(2721),
	    stubFalse = __webpack_require__(2741);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(698)(module)))

/***/ },

/***/ 2741:
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },

/***/ 2742:
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(2743),
	    baseUnary = __webpack_require__(2744),
	    nodeUtil = __webpack_require__(2745);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },

/***/ 2743:
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(2719),
	    isLength = __webpack_require__(2739),
	    isObjectLike = __webpack_require__(2736);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },

/***/ 2744:
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },

/***/ 2745:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(2722);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(698)(module)))

/***/ },

/***/ 2746:
/***/ function(module, exports) {



/***/ },

/***/ 2747:
/***/ function(module, exports) {



/***/ },

/***/ 2748:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.buildPlatformSpecificReports = undefined;
	
	var _reselect = __webpack_require__(2749);
	
	var _isEmpty = __webpack_require__(1645);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _get = __webpack_require__(1241);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var buildPlatformSpecificReports = exports.buildPlatformSpecificReports = (0, _reselect.createSelector)(function (state) {
	  return state.reportManagement.savedReports.data;
	}, function (state) {
	  return state.session.currentPlatformType;
	}, function (reports, platform) {
	  if ((0, _isEmpty2.default)(reports)) return [];
	  var platformSpecificReport = reports.filter(function (report) {
	    return (0, _get2.default)(JSON.parse(report.value), "query.platform_type", null) === platform || (0, _get2.default)(JSON.parse(report.value), "platform_type", null) === platform;
	  } // add some code to accomodate for legacy reports
	  );
	  if ((0, _isEmpty2.default)(platformSpecificReport)) return [];
	  return platformSpecificReport.sort(function (a, b) {
	    return new Date(b.created_at) - new Date(a.created_at);
	  });
	});

/***/ },

/***/ 2749:
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.defaultMemoize = defaultMemoize;
	exports.createSelectorCreator = createSelectorCreator;
	exports.createStructuredSelector = createStructuredSelector;
	function defaultEqualityCheck(a, b) {
	  return a === b;
	}
	
	function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
	  if (prev === null || next === null || prev.length !== next.length) {
	    return false;
	  }
	
	  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
	  var length = prev.length;
	  for (var i = 0; i < length; i++) {
	    if (!equalityCheck(prev[i], next[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function defaultMemoize(func) {
	  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;
	
	  var lastArgs = null;
	  var lastResult = null;
	  // we reference arguments instead of spreading them for performance reasons
	  return function () {
	    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
	      // apply arguments instead of spreading for performance.
	      lastResult = func.apply(null, arguments);
	    }
	
	    lastArgs = arguments;
	    return lastResult;
	  };
	}
	
	function getDependencies(funcs) {
	  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
	
	  if (!dependencies.every(function (dep) {
	    return typeof dep === 'function';
	  })) {
	    var dependencyTypes = dependencies.map(function (dep) {
	      return typeof dep;
	    }).join(', ');
	    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
	  }
	
	  return dependencies;
	}
	
	function createSelectorCreator(memoize) {
	  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    memoizeOptions[_key - 1] = arguments[_key];
	  }
	
	  return function () {
	    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      funcs[_key2] = arguments[_key2];
	    }
	
	    var recomputations = 0;
	    var resultFunc = funcs.pop();
	    var dependencies = getDependencies(funcs);
	
	    var memoizedResultFunc = memoize.apply(undefined, [function () {
	      recomputations++;
	      // apply arguments instead of spreading for performance.
	      return resultFunc.apply(null, arguments);
	    }].concat(memoizeOptions));
	
	    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
	    var selector = defaultMemoize(function () {
	      var params = [];
	      var length = dependencies.length;
	
	      for (var i = 0; i < length; i++) {
	        // apply arguments instead of spreading and mutate a local list of params for performance.
	        params.push(dependencies[i].apply(null, arguments));
	      }
	
	      // apply arguments instead of spreading for performance.
	      return memoizedResultFunc.apply(null, params);
	    });
	
	    selector.resultFunc = resultFunc;
	    selector.recomputations = function () {
	      return recomputations;
	    };
	    selector.resetRecomputations = function () {
	      return recomputations = 0;
	    };
	    return selector;
	  };
	}
	
	var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);
	
	function createStructuredSelector(selectors) {
	  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;
	
	  if (typeof selectors !== 'object') {
	    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
	  }
	  var objectKeys = Object.keys(selectors);
	  return selectorCreator(objectKeys.map(function (key) {
	    return selectors[key];
	  }), function () {
	    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      values[_key3] = arguments[_key3];
	    }
	
	    return values.reduce(function (composition, value, index) {
	      composition[objectKeys[index]] = value;
	      return composition;
	    }, {});
	  });
	}

/***/ }

});


// WEBPACK FOOTER //
// 1.webpack_build.js